import React from 'react';
import type { Tab } from '@/features/dashboard/types/dashboard.types';

interface DashboardTabBarProps {
    tabs: Tab[];
    activeTabId: string;
    currentUserType: string;
    isMaintenance: boolean;
    getPageLabel: (page: string) => string;
    onTabClick: (tabId: string) => void;
    onCloseTab: (tabId: string, e?: React.MouseEvent) => void;
    onCloseAllTabs: () => void;
}

const DashboardTabBar: React.FC<DashboardTabBarProps> = ({
    tabs,
    activeTabId,
    currentUserType,
    isMaintenance,
    getPageLabel,
    onTabClick,
    onCloseTab,
    onCloseAllTabs,
}) => (
    <div className="tabs-container">
        <div className="tabs-scroll-wrap">
            <div className="tabs-header">
                {tabs.map((tab) => {
                    const isTabDisabled =
                        currentUserType === 'SUPPLIER' &&
                        isMaintenance &&
                        tab.page !== 'dashboard';
                    const isDashboard = tab.id === 'dashboard';

                    return (
                        <div
                            key={tab.id}
                            className={`tab ${activeTabId === tab.id ? 'active' : ''} ${isTabDisabled ? 'disabled' : ''}`}
                            title={getPageLabel(tab.page)}
                            onClick={() => {
                                if (isTabDisabled) return;
                                onTabClick(tab.id);
                            }}
                        >
                            {isDashboard && (
                                <i className="fas fa-home tab-pin-icon" />
                            )}
                            <span className="tab-label">{getPageLabel(tab.page)}</span>
                            {!isDashboard && (
                                <button
                                    className="tab-close"
                                    onClick={(e) => {
                                        if (isTabDisabled) {
                                            e.stopPropagation();
                                            return;
                                        }
                                        onCloseTab(tab.id, e);
                                    }}
                                    disabled={isTabDisabled}
                                    title="탭 닫기"
                                >
                                    <i className="fas fa-times"></i>
                                </button>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
        {tabs.length > 1 && (
            <button className="close-all-tabs-btn" onClick={onCloseAllTabs}>
                <i className="fas fa-times-circle"></i>
                <span>전체 닫기</span>
            </button>
        )}
    </div>
);

export default DashboardTabBar;
